import React, { useLayoutEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const EventChart = ({ data }) => {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    if (!data || !Array.isArray(data) || data.length === 0) return;

    const root = am5.Root.new(chartRef.current);
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: false,
        wheelX: "panX",
        wheelY: "zoomX",
        layout: root.verticalLayout,
      })
    );

    const xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        maxDeviation: 0.2,
        baseInterval: { timeUnit: "minute", count: 1 },
        renderer: am5xy.AxisRendererX.new(root, {}),
        tooltip: am5.Tooltip.new(root, {}),
        start: 0,
      })
    );

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0,
        max: 200,
        strictMinMax: true,
      })
    );

    const occupancyConfig = {
      outOfBed: { color: am5.color(0xff0000), label: "Yataktan Çıktı" },
      inBed: { color: am5.color(0x00ff00), label: "Yatağa Girdi" },
      awayFromBed: { color: am5.color(0x0000ff), label: "Yataktan Uzakta" },
      PressureUlcers: {
        color: am5.color(0xffa500),
        label: "Bası Yaraları Önleme",
      },
    };

    const eventsData = data
      .filter(
        (item) =>
          (item?.occupancy || item?.event === "PressureUlcers") && item.time
      )
      .map((item) => {
        const key = item.occupancy || item.event;
        const cfg = occupancyConfig[key] ?? {
          color: am5.color(0x888888),
          label: key,
        };

        return {
          time: new Date(item.time).getTime(),
          label: cfg.label,
          value: 100,
          color: cfg.color,
        };
      });

    const eventSeries = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Olaylar",
        xAxis,
        yAxis,
        valueYField: "value",
        valueXField: "time",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{label}",
        }),
      })
    );

    eventSeries.strokes.template.setAll({
      strokeOpacity: 0,
    });

    eventSeries.bullets.push((root, series, dataItem) =>
      am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, {
          radius: 10,
          fill: am5.color(0xffffff),
          strokeWidth: 3,
          stroke: dataItem.dataContext.color,
        }),
      })
    );

    eventSeries.data.setAll(eventsData);

    const cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", true);

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 20,
      })
    );

    legend.data.setAll(
      Object.values(occupancyConfig).map((cfg) => ({
        name: cfg.label,
        fill: cfg.color,
        stroke: cfg.color,
      }))
    );

    return () => root.dispose();
  }, [data]);

  return <div ref={chartRef} style={{ width: "100%", height: "500px" }} />;
};

export default EventChart;
